export const SYNTHESE = { id: 14, name: 'Tab-Synthese' };
export const SYNTHESE_IZZYPILOT = { id: 76, name: 'Tab-Synthese-IzzyPilot' };
export const TRESORERIE_IZZYPILOT = { id: 77, name: 'Tab-Tresorerie-IzzyPilot' };
export const TRESORERIE = { id: 48, name: 'Tab-Tresorerie' };
export const RECETTES_DEPENSES = { id: 15, name: 'Tab-RecettesDepenses' };
export const POINTS_SENSIBLES = { id: 70, name: 'Tab-PointsSensibles' };
export const SUIVI_BUDGETAIRE = { id: 71, name: 'Tab-SuiviBudgetaire' };
export const PREVISIONNEL = { id: 74, name: 'Tab-Previsionnel' };
export const EMPRUNTS = { id: 79, name: 'Tab-Emprunts' };

export const OPERATIONS = { id: 17, name: 'Tab-Operations' };
export const SUIVI_TVA = { id: 21, name: 'Tab-SuiviDeTva' };
export const RELEVES_BANCAIRES = { id: 36, name: 'Tab-RelevesBancaires' };

export const MES_DEPOTS = { id: 28, name: 'Tab-MesDepots' };
export const MES_DOCUMENTS = { id: 29, name: 'Tab-MesDocuments' };

export const MES_DEVIS_FACTURES = { id: 22, name: 'DevisFacture' };

export const AIDE = { id: 51, name: 'Page-Aide' };

export const COMPTE = { id: 51, name: 'Page-Compte' };

export const MARKETPLACE = { id: 92, name: 'Tab-Marketplace' };

export const EULA = { id: 93, name: 'Page-Eula' };

export const MODULE_TABLEAU_DE_BORD = [
  SYNTHESE,
  SYNTHESE_IZZYPILOT,
  TRESORERIE_IZZYPILOT,
  TRESORERIE,
  RECETTES_DEPENSES,
  POINTS_SENSIBLES,
  SUIVI_BUDGETAIRE,
  PREVISIONNEL,
];

export const MODULE_OPERATIONS = [
  OPERATIONS,
  SUIVI_TVA,
  RELEVES_BANCAIRES,
  EMPRUNTS,
];

export const MODULE_COFFRE_FORT = [
  MES_DEPOTS,
  MES_DOCUMENTS,
];

export default {
  SYNTHESE,
  SYNTHESE_IZZYPILOT,
  TRESORERIE_IZZYPILOT,
  TRESORERIE,
  RECETTES_DEPENSES,
  POINTS_SENSIBLES,
  SUIVI_BUDGETAIRE,
  OPERATIONS,
  SUIVI_TVA,
  RELEVES_BANCAIRES,
  EMPRUNTS,
  MES_DEVIS_FACTURES,
  MES_DEPOTS,
  AIDE,
  COMPTE,
  MODULE_TABLEAU_DE_BORD,
  MODULE_OPERATIONS,
  MODULE_COFFRE_FORT,
  MARKETPLACE,
  EULA,
};
